<template>
   
  <div>
     
    <div class="full-width-carousel">
       
      <div class="carousel-container">
         
        <div class="carousel-track">
           
          <div
            :class="`carousel-slide cursor-pointer ${destaque.classe} slide-${i}`"
            :id="i"
            @click="openlink(destaque)"
            v-for="(destaque, i) in destaquesSite"
            :key="i"
          >
            <div class="slide-content" v-if="false">
               
              <h3 class="text-shadow--custom">{{ destaque.descricao }}</h3>
               
              <p
                class="text-shadow--custom"
                v-if="
                  destaque &&
                  destaque.produto_detalhe &&
                  destaque.produto_detalhe.nome
                "
              >
                {{ destaque.produto_detalhe.nome }}  
              </p>
               
              <a
                @click="openProduct(destaque.produto_detalhe)"
                class="btn-banner cursor-pointer text-shadow--custom"
                >{{ destaque.nome }}</a
              >
            </div>
            <div class="slide-image" v-if="false">
               
              <img
                :src="
                  $util.getImageBackend(destaque.imagem_produto) ||
                  '/assets/loading2.gif'
                "
                alt="Imagem"
              />
            </div>
             
          </div>
           
        </div>
        <button class="carousel-button prev">&lt;</button>  
        <button class="carousel-button next">&gt;</button>  
        <div class="carousel-indicators" style="display: none !important"></div>
         
      </div>
       
    </div>
     
  </div>
</template>

<script>
import { gerenciadorUrl } from "@/config/gerenciadorConfig";

export default {
  data() {
    return {
      destaquesSite: [
        {
          classe: "bgcarrossel",
          linkRedirect: "/products?categoria=9", // nao importa aqui pra baixo
          id: 154,
          nome: "Nome destaque",
          descricao: "Descricao destaque",
          backgroundBase64: null,
          criado_em: "2025-11-11T17:24:30.724243-03:00",
          atualizado_em: "2025-11-11T17:24:30.724267-03:00",
          produto: 23,
          produto_detalhe: {
            id: 23,
            nome: "Cordão Óptico Duplex 20 m LC/UPC–LC/UPC MM 50/125 µm OM3 2.0 mm LSZH – Connection Optical",
            descricao:
              "Cordão óptico duplex multimodo OM3 50/125 µm com conectores LC/UPC em ambas as extremidades, 20 m de comprimento e revestimento LSZH. Oferece excelente desempenho para transmissões de alta velocidade em curtas e médias distâncias.",
            detalhamento:
              '["Ideal para interliga\\u00e7\\u00e3o de switches, servidores e equipamentos em data centers e redes locais (LAN) baseadas em fibra \\u00f3ptica multimodo OM3."]',
            preco: "78.90",
            estoque: 20,
            estoque_referencia: 10,
            data_estoque_baixo: null,
            tags: null,
            informacoes:
              '{"Nome do Fabricante": "Connection Optical", "Part Number": "CO-DF-LCU-LCU-MM20", "Modelo": "Duplex", "Conector-Polimento A": "LC/UPC", "Conector-Polimento B": "LC/UPC", "Tipo de Polaridade": "(Tx) para (Rx)", "Tipo de Fibra": "Multimodo (OM3) 50/125", "Comprimento de onda": "850 nm", "Tamanho do Cabo": "20 m", "Di\\u00e2metro do Cabo": "2.0 mm", "Revestimento do Cabo": "LSZH (Low Smoke Zero Halogen)", "Perda de inser\\u00e7\\u00e3o": "\\u2264 0.3dB m\\u00e1ximo (Valor t\\u00edpico perde: \\u2264 0.22 dB)", "Perda de retorno": "\\u2265 20dB", "Raio de Curvatura M\\u00ednima": "7.5 mm", "Temperatura de Opera\\u00e7\\u00e3o": "\\u201320 \\u00b0C ~ +70 \\u00b0C", "Cor": "Aqua", "Certifica\\u00e7\\u00f5es": "CE, FCC, RoHS"}',
            peso: 0,
            altura: 0,
            largura: 0,
            comprimento: 0,
            sku: "1754936284428",
            criado_em: "2025-11-11T12:55:15.808640-03:00",
            atualizado_em: "2025-11-11T17:24:30.723368-03:00",
            categoria: 7,
            subcategoria: 1,
            filtroproduto: 8,
          },
          imagem_produto:
            `${gerenciadorUrl()}/images/IMAGEM 22_8.png`,
        },
        {
          classe: "bgcarrossel1",
          linkRedirect: "/products?categoria=9", // nao importa aqui pra baixo
          id: 154,
          nome: "Nome destaque",
          descricao: "Descricao destaque",
          backgroundBase64: null,
          criado_em: "2025-11-11T17:24:30.724243-03:00",
          atualizado_em: "2025-11-11T17:24:30.724267-03:00",
          produto: 23,
          produto_detalhe: {
            id: 23,
            nome: "Cordão Óptico Duplex 20 m LC/UPC–LC/UPC MM 50/125 µm OM3 2.0 mm LSZH – Connection Optical",
            descricao:
              "Cordão óptico duplex multimodo OM3 50/125 µm com conectores LC/UPC em ambas as extremidades, 20 m de comprimento e revestimento LSZH. Oferece excelente desempenho para transmissões de alta velocidade em curtas e médias distâncias.",
            detalhamento:
              '["Ideal para interliga\\u00e7\\u00e3o de switches, servidores e equipamentos em data centers e redes locais (LAN) baseadas em fibra \\u00f3ptica multimodo OM3."]',
            preco: "78.90",
            estoque: 20,
            estoque_referencia: 10,
            data_estoque_baixo: null,
            tags: null,
            informacoes:
              '{"Nome do Fabricante": "Connection Optical", "Part Number": "CO-DF-LCU-LCU-MM20", "Modelo": "Duplex", "Conector-Polimento A": "LC/UPC", "Conector-Polimento B": "LC/UPC", "Tipo de Polaridade": "(Tx) para (Rx)", "Tipo de Fibra": "Multimodo (OM3) 50/125", "Comprimento de onda": "850 nm", "Tamanho do Cabo": "20 m", "Di\\u00e2metro do Cabo": "2.0 mm", "Revestimento do Cabo": "LSZH (Low Smoke Zero Halogen)", "Perda de inser\\u00e7\\u00e3o": "\\u2264 0.3dB m\\u00e1ximo (Valor t\\u00edpico perde: \\u2264 0.22 dB)", "Perda de retorno": "\\u2265 20dB", "Raio de Curvatura M\\u00ednima": "7.5 mm", "Temperatura de Opera\\u00e7\\u00e3o": "\\u201320 \\u00b0C ~ +70 \\u00b0C", "Cor": "Aqua", "Certifica\\u00e7\\u00f5es": "CE, FCC, RoHS"}',
            peso: 0,
            altura: 0,
            largura: 0,
            comprimento: 0,
            sku: "1754936284428",
            criado_em: "2025-11-11T12:55:15.808640-03:00",
            atualizado_em: "2025-11-11T17:24:30.723368-03:00",
            categoria: 7,
            subcategoria: 1,
            filtroproduto: 8,
          },
          imagem_produto:
            `${gerenciadorUrl()}/images/IMAGEM 22_8.png`,
        },
        {
          classe: "bgcarrossel2",
          linkRedirect: "/products?q=NE8000%20M4%20DC", // nao importa aqui pra baixo
          id: 154,
          nome: "Nome destaque",
          descricao: "Descricao destaque",
          backgroundBase64: null,
          criado_em: "2025-11-11T17:24:30.724243-03:00",
          atualizado_em: "2025-11-11T17:24:30.724267-03:00",
          produto: 23,
          produto_detalhe: {
            id: 23,
            nome: "Cordão Óptico Duplex 20 m LC/UPC–LC/UPC MM 50/125 µm OM3 2.0 mm LSZH – Connection Optical",
            descricao:
              "Cordão óptico duplex multimodo OM3 50/125 µm com conectores LC/UPC em ambas as extremidades, 20 m de comprimento e revestimento LSZH. Oferece excelente desempenho para transmissões de alta velocidade em curtas e médias distâncias.",
            detalhamento:
              '["Ideal para interliga\\u00e7\\u00e3o de switches, servidores e equipamentos em data centers e redes locais (LAN) baseadas em fibra \\u00f3ptica multimodo OM3."]',
            preco: "78.90",
            estoque: 20,
            estoque_referencia: 10,
            data_estoque_baixo: null,
            tags: null,
            informacoes:
              '{"Nome do Fabricante": "Connection Optical", "Part Number": "CO-DF-LCU-LCU-MM20", "Modelo": "Duplex", "Conector-Polimento A": "LC/UPC", "Conector-Polimento B": "LC/UPC", "Tipo de Polaridade": "(Tx) para (Rx)", "Tipo de Fibra": "Multimodo (OM3) 50/125", "Comprimento de onda": "850 nm", "Tamanho do Cabo": "20 m", "Di\\u00e2metro do Cabo": "2.0 mm", "Revestimento do Cabo": "LSZH (Low Smoke Zero Halogen)", "Perda de inser\\u00e7\\u00e3o": "\\u2264 0.3dB m\\u00e1ximo (Valor t\\u00edpico perde: \\u2264 0.22 dB)", "Perda de retorno": "\\u2265 20dB", "Raio de Curvatura M\\u00ednima": "7.5 mm", "Temperatura de Opera\\u00e7\\u00e3o": "\\u201320 \\u00b0C ~ +70 \\u00b0C", "Cor": "Aqua", "Certifica\\u00e7\\u00f5es": "CE, FCC, RoHS"}',
            peso: 0,
            altura: 0,
            largura: 0,
            comprimento: 0,
            sku: "1754936284428",
            criado_em: "2025-11-11T12:55:15.808640-03:00",
            atualizado_em: "2025-11-11T17:24:30.723368-03:00",
            categoria: 7,
            subcategoria: 1,
            filtroproduto: 8,
          },
          imagem_produto:
            `${gerenciadorUrl()}/images/IMAGEM 22_8.png`,
        },
      ],
    };
  },
  mounted() {
    return;
    this.$api.getDestaquesSite().then((res) => {
      this.destaquesSite = res.data;
      if (this.destaquesSite.length) {
        this.getProdutos();
      }
    });
  },
  methods: {
    openlink(destaque) {
      window.location.href = destaque.linkRedirect;
    },
    openProduct(produto) {
      localStorage.setItem("productNameMeta", produto.nome);
      this.$router.push({
        name: 'product',
        params: { id: produto.id }
      });
    },
    getProdutos() {
      for (let i = 0; i < this.destaquesSite.length; i++) {
        const destaque = this.destaquesSite[i];
        this.getImagem(destaque, i);
        this.$api.getProduto(destaque.produto).then((res) => {
          this.destaquesSite[i]["produto_detalhe"] = res.data;
        });
      }
    },
    getImagem(destaque, index) {
      this.$api.getImagemProduto({ produto: destaque.produto }).then((res) => {
        if (res.data.length) {
          this.destaquesSite[index]["imagem_produto"] = res?.data[0].base64;
        } else {
          this.destaquesSite[index]["imagem_produto"] = null;
        }
        this.$forceUpdate();
      });
    },
  },
  created() {
    setTimeout(() => {
      const track = document.querySelector(".carousel-track");
      if (!track) return;

      const slides = Array.from(track.children);
      const nextButton = document.querySelector(".carousel-button.next");
      const prevButton = document.querySelector(".carousel-button.prev");
      const indicatorsContainer = document.querySelector(
        ".carousel-indicators"
      );
      let slideWidth =
        slides.length > 0 ? slides[0].getBoundingClientRect().width : 0;
      let currentIndex = 0;
      let autoPlayInterval;

      if (slides.length <= 1) {
        if (nextButton) nextButton.style.display = "none";
        if (prevButton) prevButton.style.display = "none";
        if (indicatorsContainer) indicatorsContainer.style.display = "none";
        return;
      }

      slides.forEach((_, index) => {
        const button = document.createElement("button");
        button.classList.add("indicator");
        if (index === 0) button.classList.add("active");
        button.addEventListener("click", () => {
          moveToSlide(index);
          resetAutoPlay();
        });
        indicatorsContainer.appendChild(button);
      });

      const indicators = Array.from(indicatorsContainer.children);

      const moveToSlide = (targetIndex) => {
        slideWidth =
          slides.length > 0 ? slides[0].getBoundingClientRect().width : 0;
        if (slideWidth === 0) return; // Evita erro se o carrossel estiver oculto
        track.style.transform =
          "translateX(-" + slideWidth * targetIndex + "px)";

        if (indicators[currentIndex])
          indicators[currentIndex].classList.remove("active");
        if (indicators[targetIndex])
          indicators[targetIndex].classList.add("active");

        currentIndex = targetIndex;
      };

      const handleNext = () => {
        const nextIndex = (currentIndex + 1) % slides.length;
        moveToSlide(nextIndex);
      };

      const handlePrev = () => {
        const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
        moveToSlide(prevIndex);
      };

      nextButton.addEventListener("click", () => {
        handleNext();
        resetAutoPlay();
      });

      prevButton.addEventListener("click", () => {
        handlePrev();
        resetAutoPlay();
      });

      const startAutoPlay = () => {
        autoPlayInterval = setInterval(handleNext, 5000);
      };

      const resetAutoPlay = () => {
        clearInterval(autoPlayInterval);
        startAutoPlay();
      }; // Recalcular a largura do slide ao redimensionar a janela

      window.addEventListener("resize", () => {
        moveToSlide(currentIndex);
      });

      startAutoPlay();
    }, 2500);
  },
};
</script>

<style>
/* --- 3. Carrossel Full-Width --- */
.full-width-carousel {
  width: 100%;
  background-color: unset;
  padding: 0px 0 !important;
}
.carousel-container {
  position: relative;
  width: 100%;
  max-width: var(--max-width);
  height: 85vh;
  margin: 0 auto;
  border-radius: var(--border-radius);
  overflow: hidden;
}
.carousel-track {
  display: flex;
  height: 100%;
  transition: transform 0.5s ease-in-out;
}
.carousel-slide {
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--color-text-light);
  padding: 0 80px;
  background-size: cover;
  background-position: center;
  /* ✨ ALTERAÇÕES AQUI para o efeito de brilho: */
  position: relative;
  overflow: hidden;
}
.slide-1 {
  /* background-image: linear-gradient(75deg, #002f4b 40%, #00b8d4 150%); */
}

.slide-content {
  max-width: 45%;
}
.carousel-slide h3 {
  font-size: 3rem;
  font-weight: 700;
  text-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
}
.carousel-slide p {
  font-size: 1.3rem;
  margin: 10px 0 25px 0;
  opacity: 0.9;
}
.carousel-slide .btn-banner {
  background-color: var(--color-text-light);
  color: var(--color-primary);
  padding: 14px 30px;
  border-radius: var(--border-radius);
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s;
  text-decoration: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  display: inline-block;
}
.carousel-slide .btn-banner:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}
.slide-image {
  max-width: 45%;
}
.slide-image img {
  max-width: 100%;
  height: auto;
  max-height: 320px;
  object-fit: contain;
  border-radius: 10px;
  transition: transform 0.8s ease;
}
.slide-image img:hover {
  max-width: 100%;
  height: auto;
  max-height: 320px;
  object-fit: contain;
  border-radius: 10px;
  transform: scale(1.1) translate(0%, 0%);
}
.carousel-button {
  position: absolute;
  bottom: 13px;
  top: auto;
  transform: none;
  background-color: transparent;
  border: 1px solid rgba(180, 180, 180, 0.55);
  border-radius: 50%;
  width: 34px;
  height: 34px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
  transition: background-color 0.3s, border-color 0.3s, box-shadow 0.3s;
  color: rgba(200, 200, 200, 0.8);
  font-size: 0.85rem;
  z-index: 10;
}
.carousel-button:hover {
  background-color: rgba(0, 191, 255, 0.18);
  border-color: #00bfff;
  color: #00bfff;
  box-shadow: 0 0 8px rgba(0, 191, 255, 0.3);
}
.carousel-button.prev {
  left: calc(50% - 60px);
}
.carousel-button.next {
  right: calc(50% - 60px);
}
.carousel-indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
}
.indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: background-color 0.3s;
}
.indicator.active {
  background-color: #afafaf;
}
/* --- 6. Responsividade --- */
@media (max-width: 1400px) {
  .product-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 1200px) {
  .main-content-wrapper {
    grid-template-columns: 1fr;
  }
  .sidebar {
    display: none;
  }
}
@media (max-width: 992px) {
  .product-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .header-content {
    justify-content: center;
  }
  .search-bar {
    order: 3;
    width: 100%;
    margin-top: 15px;
  }
  .carousel-slide h3 {
    font-size: 2.2rem;
  }
  .carousel-slide p {
    font-size: 1.1rem;
  }
  .slide-content {
    max-width: 100%;
    text-align: center;
  }
  .slide-image {
    display: none;
  }
  .carousel-slide {
    justify-content: center;
  }
}
@media (max-width: 768px) {
  .main-nav ul {
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
  }
  .footer-links-grid {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .footer-column {
    width: 100%;
  }
  .carousel-container {
    height: 300px;
    border-radius: 0;
  }
  .carousel-slide {
    padding: 30px;
  }
}
@media (max-width: 576px) {
  .product-grid {
    grid-template-columns: 1fr;
  }
  .header-actions {
    width: 100%;
    justify-content: space-around;
    margin-top: 10px;
  }
  .carousel-slide h3 {
    font-size: 1.8rem;
  }
  .carousel-slide p {
    display: none;
  }
  .carousel-button {
    width: 34px;
    height: 34px;
  }
}

/* --- Estilos do Backgrounds (seus) --- */
.bgcarrossel {
  background-image: url("@/assets/img/banner/banner-base.jpg");
  background-position: center;
  background-size: contain;
  background-repeat: repeat-x;
}
.bgcarrossel1 {
  background-image: url("@/assets/img/banner/banner-base.jpg");
  background-position: center;
  background-size: contain;
  background-repeat: repeat-x;
}
.bgcarrossel2 {
  background-image: url("@/assets/img/banner/banner-base.jpg");
  background-position: center;
  background-size: contain;
  background-repeat: repeat-x;
}

/* --- EFEITO DE BRILHO (NOVO) --- */
.carousel-slide::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  height: 100%;
  width: 100%;
  z-index: 1;

  /* ✨ ALTERAÇÃO: Aumentando a largura da faixa e mantendo a sutileza */
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0) -50%,        /* Início da faixa grossa (40%) */
    rgba(255, 255, 255, 0.01) 70%,      /* Pico do brilho (50% - 20% de opacidade) */
    rgba(255, 255, 255, 0) 500%,        /* Fim da faixa grossa (60%) */
    rgba(255, 255, 255, 0) 100%
  );
  
  /* Mantido o ângulo e a velocidade lenta (8s) */
  transform: skewX(-45deg); 
  animation: brilhoSuave 3s infinite ease-in-out;
}

/* @keyframes brilhoSuave permanece o mesmo */

/* Definição da Animação (Permanece a mesma, apenas a duração muda acima) */
@keyframes brilhoSuave {
  0% {
    left: -150%; /* Inicia o brilho completamente fora da div à esquerda */
  }
  100% {
    left: 150%; /* Move o brilho para fora da div à direita */
  }
}
</style>